import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

interface FaqItemProps {
  question: string;
  children: React.ReactNode;
}

const FaqItem = ({ question, children }: FaqItemProps) => (
  <div className="mb-8">
    <h3 className="font-bold text-xl mb-2">{question}</h3>
    <div className="text-lg leading-relaxed">{children}</div>
  </div>
);

const Faq = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="container mx-auto px-4 py-8 text-white">
      <h1 className="text-4xl font-bold text-center mb-8">FAQ</h1>
      <FaqItem question="Can I import players without using Chrome on a computer?">
        <p>
          At this moment, we rely on the Chrome extension to import players.
          This must be done using a computer. Once imported, your players are
          saved in our database, allowing you to solve SBCs on any device.
        </p>
      </FaqItem>

      <FaqItem question="Is it safe to use player import?">
        <p className="mb-4">
          We have carefully read the{" "}
          <a
            href="https://help.ea.com/en/help/fifa/fifa-rules/#connecting-to-ea"
            target="_blank"
            rel="noreferrer"
            className="text-blue-400 underline"
          >
            TOS from EA
          </a>{" "}
          and designed our extension to follow those guidelines. There are two
          key points:
        </p>
        <p className="italic mb-4">
          “We don’t want you to use third-party apps and browser extensions
          because it puts your account at risk. When you use these third-party
          apps and browser extensions, your login info can be visible to third
          parties and someone could use that info to take over your account.
          Browser extensions can capture your passwords, track your web
          browsing, insert ads into web pages you visit, and more.”
        </p>
        <p className="mb-4">
          Our extension does not access your login credentials or interact with
          the FUT Web App. It only reads the data sent to your browser.
        </p>
        <p className="italic mb-4">
          “Use any robot, spider or other automated device or process to access
          EA Services for any purpose such as scraping data, abuse EA Services,
          account creation, or copying material.”
        </p>
        <p>
          Our import feature is not automated; you must manually navigate
          through the pages. While we do our best to follow the guidelines, we
          cannot guarantee 100% safety. Please reach out via our Contact page if
          you have any questions or concerns.
        </p>
      </FaqItem>

      <FaqItem question="I am interested in the premium subscription, but would like a free trial before deciding">
        <p>
          Currently, there is no free trial available due to previous misuse by
          some users.
        </p>
      </FaqItem>

      <FaqItem question="How can I get in contact with you?">
        <p>
          {/*HERE ALSO POSSIBLE TO ADD DIRECT DISCORD INVITE LINK*/}
          Join our Discord server or send us a message via the{" "}
          <NavLink to="/contact" className="text-blue-400 underline">
            Contact page
          </NavLink>
          . We value your feedback and are always happy to engage with our
          users!
        </p>
      </FaqItem>
    </main>
  );
};

export default Faq;
